/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/

/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/



import EditDoctorDataContent from "components/content/EditDoctorDataContent";
import DefaultDashboardLayout from "layouts/dashboard/DefaultDashboardLayout";
import { FC, useMemo } from "react";
import { useLocation, useParams } from "react-router-dom";

/**
 * Doctor/provider profile editing page.
 * Allows modification of existing doctor/provider information.
 * 
 * Features:
 * - Edit doctor profile information
 * - Update specialties and credentials
 * - Modify schedule and availability
 * - Update contact information
 * - Form validation with error handling
 * - Integration with provider management system
 * 
 * The page receives doctorId via:
 * - Navigation state from doctors list page, or
 * - URL parameter for direct access
 * 
 * @returns {JSX.Element} Edit doctor page component
 */
const EditDoctorPage: FC = () => {
  const { state } = useLocation();
  const { doctorId } = state;

  let { id } = useParams();

  const idResult = useMemo<string>(() => doctorId || id, [doctorId, id]);

  console.log(id);

  return (
    <DefaultDashboardLayout>
      <EditDoctorDataContent doctorId={idResult} />
    </DefaultDashboardLayout>
  );
};

export default EditDoctorPage;

